import React from "react";
import * as PropTypes from "prop-types";
import id from "@irati/utils/id";
import { FormattedMessage } from "@irati/utils/lang";
import { RouterLink } from "@irati/ui/src/Link";
import tracking from "@irati-tracking/perks/perks";
import { OptionIcon } from "../../styled";
var DealsMenuLink = function (props, _a) {
    var apps = _a.apps;
    return (React.createElement(RouterLink, { id: id("link-my-perks", props), onClick: tracking.viewMyPerks, to: "/account", plain: true, app: apps.PERKS },
        React.createElement(OptionIcon, { icon: "myPerks" }),
        React.createElement(FormattedMessage, { id: "platform.userMenuContext.deals.href.text" })));
};
DealsMenuLink.contextTypes = {
    apps: PropTypes.object.isRequired
};
export default DealsMenuLink;
